import { Pipe, PipeTransform } from "@angular/core"

@Pipe({
    name: "millisecondsToMinutesSeconds",
    pure: true,
})
export class MillisecondsToMinutesSecondsPipe implements PipeTransform {

    public transform(value: number): string {
        let seconds = value / 1000;
        let minutes = 0;
        while (seconds >= 60) {
            minutes += 1;
            seconds -= 60;
        }

        return `${minutes} min ${seconds} secs`;
    }
}
